(function () {
    'use strict';

    angular
        .module('app.influencerManagementLog', [])
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('home.influencerManagementLog', {
                    requireLogin: true,
                    url: 'admin/influencerManagementLog',
                    templateUrl: 'app/admin/influencerManagement/influencerManagementLog/influencerManagementLog.html?app_v=deployDate',
                    controller: 'influencerManagementLogCtrl',
                    scope: {},
                    data: {
                        authorizedRoles: ['Administrator', 'Achoo Analyst'],
                        navMarker: ['admin', 'influencerManagementLog']
                    },
                    params: {
                        
                    }
                });
        }]);
})();